import { useFlag } from '@unleash/proxy-client-react';
import { TrafficCone } from 'lucide-react';
import type { ReactNode } from 'react';

export function MaintenanceWrapper({ children }: { children: ReactNode }) {
  const isEnabled = useFlag('pms.v1.maintenance');
  if (isEnabled) return <MaintenanceTemplate />;
  return children;
}

function MaintenanceTemplate() {
  return (
    <div
      className="max-w-7xl px-4 mx-auto w-full flex flex-col lg:gap-20 gap-10 h-screen justify-center relative"
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'center',
        padding: 16,
        maxWidth: '600px',
        margin: '0 auto',
      }}
    >
      <TrafficCone
        size={100}
        className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] xl:size-[1000px] lg:size-[800px] md:size-[600px] size-0 text-muted-foreground opacity-5 z-0"
      />
      <section className="lg:space-y-12 space-y-6 z-10">
        <h1 className="lg:text-7xl text-5xl font-serif font-semibold">We&apos;ll Be Right Back!</h1>
        <div className="flex flex-col gap-10">
          <p className="text-muted-foreground text-xl max-w-2xl">
            We&apos;re currently adding some exciting new features and improvements to serve you better.
          </p>
          <p className="text-muted-foreground text-xl max-w-xl">
            We&apos;ll be back shortly – thank you for your patience!
          </p>
        </div>
      </section>
    </div>
  );
}
